import makeACModel from './makeACModel'

export default makeACModel
